export const resourceTypeMapping = {
  paper: {
    name: '全部资源',
    value: 'paper',
    tab: '全部',
    field: 'all',
    type: 'Paper',
  },
  periodical: {
    name: '期刊论文',
    value: 'periodical',
    tab: '期刊',
    field: 'perio',
    type: 'Periodical',
  },
  magazine: {
    name: '期刊母体',
    value: 'magazine',
    tab: '期刊',
    field: 'perioInfo',
  },
  thesis: {
    name: '学位论文',
    value: 'thesis',
    tab: '学位',
    field: 'degree',
    type: 'Thesis',
  },
  thesiscatalog: {
    name: '学位目录'
  },
  conference: {
    name: '会议论文',
    value: 'conference',
    tab: '会议',
    field: 'conference',
    type: 'Conference'
  },
  meeting: {
    name: '会议母体(名录)',
    value: 'meeting',
    tab: '会议',
    field: 'conferenceInfo'
  },
  patent: {
    name: '专利',
    value: 'patent',
    tab: '专利',
    field: 'patent',
    type: 'Patent'
  },
  // 中文q=DBID:CHI，英文q=DBID:ENG
  nstr: {
    name: '科技报告',
    value: 'nstr',
    tab: '科技报告',
    field: 'tech',
    type: 'Nstr',
  },
  cstad: {
    name: '成果',
    value: 'cstad',
    tab: '成果',
    field: 'techResult',
    type: 'Cstad'
  },
  standard: {
    name: '标准',
    value: 'standard',
    tab: '标准',
    field: 'standards',
    type: 'Standard',
  },
  law: {
    name: '法规',
    value: 'law',
    tab: '法规',
    field: 'legislation',
    type: 'Claw',
  },
  localchronicleitem: {
    name: '方志条目',
    value: 'localchronicleitem',
    tab: '地方志',
    field: 'localChronicleItems',
    type: 'LocalChronicleItem',
  },
  localchronicle: {
    name: '志书',
    value: 'localchronicle',
    tab: '地方志',
    field: 'localChronicle',
    type: 'LocalChronicle',
  },
  video: {
    name: '视频',
    value: 'video',
    tab: '视频',
    field: 'video',
    type: 'Video',
  },
  // 目前没有专门的图书分类，只是展示在全部下
  book: {
    name: '图书',
    value: 'book',
    tab: '图书',
    field: 'book',
    type: 'Book',
  },
  blog: {
    name: '论文'
  }
};
const {
  paper,
  periodical,
  magazine,
  thesis,
  conference,
  meeting,
  patent,
  nstr,
  cstad,
  standard,
  law,
  localchronicle,
  localchronicleitem,
  video
} = resourceTypeMapping;

// 导航tab数据
// 切换 tab 时默认走的的都是第一个按钮的资源类型
// 按回车时，取路由 query 的资源类型
export const tabList = [
  // 如果没有路由参数，默认取全部资源
  { label: paper.tab, firstResource: paper.value, secondResource: null },
  // 期刊对应着两个资源：一个是论文，一个是母体
  {
    label: periodical.tab,
    firstResource: periodical.value,
    secondResource: magazine.value
  },
  { label: thesis.tab, firstResource: thesis.value, secondResource: null },
  // 会议对应着两个资源：一个是论文，一个是母体
  {
    label: conference.tab,
    firstResource: conference.value,
    secondResource: meeting.value
  },
  { label: patent.tab, firstResource: patent.value, secondResource: null },
  { label: nstr.tab, firstResource: nstr.value, secondResource: null },
  { label: cstad.tab, firstResource: cstad.value, secondResource: null },
  { label: standard.tab, firstResource: standard.value, secondResource: null },
  { label: law.tab, firstResource: law.value, secondResource: null },
  // 地方志对应着两个资源：一个是条目，一个是志书
  { label: localchronicleitem.tab, firstResource: localchronicleitem.value, secondResource: localchronicle.value },
  { label: video.tab, firstResource: video.value, secondResource: null }
];
// 镜像环境用，只展示 全部、期刊、学位、会议、科技报告
export const mirrorTabList = [
  // 如果没有路由参数，默认取全部资源
  { label: paper.tab, firstResource: paper.value, secondResource: null },
  // 期刊对应着两个资源：一个是论文，一个是母体
  {
    label: periodical.tab,
    firstResource: periodical.value,
    secondResource: magazine.value
  },
  { label: thesis.tab, firstResource: thesis.value, secondResource: null },
  // 会议对应着两个资源：一个是论文，一个是母体
  {
    label: conference.tab,
    firstResource: conference.value,
    secondResource: meeting.value
  },
  { label: nstr.tab, firstResource: nstr.value, secondResource: null },
];

// 快捷限定词数据
const quickKeyword = {
  [paper.value]: ['题名', '作者', '作者单位', '关键词', '摘要'],
  [periodical.value]: ['题名', '作者', '作者单位', '关键词', '摘要', '刊名', '基金', '中图分类号'],
  [thesis.value]: ['题名', '作者', '学位授予单位', '关键词', '摘要', '专业', '导师', '中图分类号'],
  [conference.value]: ['题名', '作者', '作者单位', '关键词', '摘要', '会议名称', '主办单位'],
  [patent.value]: [
    '题名',
    '摘要',
    '申请号/专利号',
    '公开号/公告号',
    '申请人/专利权人',
    '发明人/设计人',
    '主分类号',
    '分类号'
  ],
  [nstr.value]: ['题名', '作者', '作者单位', '关键词', '摘要', '计划名称', '项目名称'],
  [cstad.value]: ['题名', '完成人', '完成单位', '关键词', '摘要', '中图分类号'],
  [standard.value]: ['题名', '关键词','摘要', '标准编号','起草人', '起草单位', '发布单位'],
  [law.value]: ['题名', '颁布部门', '终审法院'],
  [localchronicleitem.value]: ['正文', '题名', '编纂人员', '编纂单位'],
  [video.value]: ['标题', '主讲人', '机构', '关键词']
};
quickKeyword[magazine.value] = quickKeyword[periodical.value];
quickKeyword[meeting.value] = quickKeyword[conference.value];
quickKeyword[localchronicle.value] = quickKeyword[localchronicleitem.value];

/**
 * topSearch 需要根据资源转换的字段
 */
const changeWords = {
  paper: {
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|主讲人|起草人': '作者',
    '学位授予单位|申请人/专利权人|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|机构': '作者单位',
  },
  periodical: {
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|主讲人|起草人': '作者',
    '学位授予单位|申请人/专利权人|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|机构': '作者单位',
  },
  thesis: {
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|主讲人|起草人': '作者',
    '作者单位|申请人/专利权人|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|机构': '学位授予单位',
  },
  conference: {
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|主讲人|起草人': '作者',
    '学位授予单位|申请人/专利权人|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|机构': '作者单位',
  },
  patent: {
    '关键词': '',
    '题名|标题': '专利名称',
    '作者|完成人|编纂人员|名师/主讲人|起草人': '发明人/设计人',
    '学位授予单位|作者单位|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|主讲人|机构': '申请人/专利权人',
  },
  nstr: {
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|起草人': '作者',
    '学位授予单位|申请人/专利权人|完成单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|主讲人|机构': '作者单位',
  },
  cstad: {
    '专利名称|标题': '题名',
    '发明人/设计人|作者|编纂人员|名师/主讲人|起草人': '完成人',
    '学位授予单位|申请人/专利权人|作者单位|起草单位|颁布部门|编纂单位|机构/主讲人单位|主讲人|机构': '完成单位',
  },
  standard: {
    '摘要': '',
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|作者': '起草人',
    '学位授予单位|申请人/专利权人|完成单位|作者单位|颁布部门|编纂单位|机构/主讲人单位|主讲人|机构': '起草单位',
  },
  law: {
    '摘要': '',
    '关键词': '',
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|编纂人员|名师/主讲人|作者|起草人': '',
    '学位授予单位|申请人/专利权人|完成单位|作者单位|起草单位|编纂单位|机构/主讲人单位|主讲人|机构': '颁布部门',
  },
  localchronicleitem: {
    '摘要': '',
    '关键词': '',
    '专利名称|标题': '题名',
    '发明人/设计人|完成人|名师/主讲人|作者|起草人': '编纂人员',
    '学位授予单位|申请人/专利权人|完成单位|作者单位|起草单位|颁布部门|机构/主讲人单位|主讲人|机构': '编纂单位',
  },
  video: {
    '摘要': '',
    '专利名称|题名': '标题',
    '发明人/设计人|完成人|编纂人员|作者|起草人': '主讲人',
    '学位授予单位|申请人/专利权人|完成单位|作者单位|起草单位|颁布部门|编纂单位': '机构',
  },
}

export { quickKeyword, changeWords };
